module.exports = __webpack_public_path__ + "img/y_p3_x2.5edc4878.svg";